import {Router, RouterModule, Routes } from "@angular/router";
import { PageLayoutaddUserComponent } from "./add-edit-user/adduser.component";
import { PageLayoutUserComponent } from "./user/user.component";
import { UserManagementComponent } from "./user-management.component";
import { PageLayoutUserRightsSummaryComponent } from "./user-rights-summary/userrightssummary.component";
import { AuthGuard } from "../shared/auth-admin.guard";

export const UserManagementRoutes:Routes=[{
        path:'user-management',
        children:[
            { path: 'user',component: PageLayoutUserComponent},
            { path: 'add-user/:id', component: PageLayoutaddUserComponent},
            { path: 'user-rights-summary',component:PageLayoutUserRightsSummaryComponent}
        ],
        canActivateChild:[AuthGuard],
        canActivate: [AuthGuard],
        component:UserManagementComponent
}]
export const UserManagementRoutingModule=RouterModule.forChild(UserManagementRoutes)


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-management/user-management-routing.module.ts